import ResponseDataExtractor from '../../../../common/utils/ResponseDataExtractor';
import helper from '../../../../helper';
import RetryWorker from '../../../../common/utils/RetryWorker';

export default {
	async getQueuedBookings({ commit, state }, params) {
        if(state.queuedBookings.isLoading) {
            // Prevent duplicate calling refresh list
            return;
        }

        await commit('SET_QUEUED_BOOKINGS', {
            ...state.queuedBookings,
            isLoading: true,
            isFetched: false
        });
        return new Promise((mainResolve, mainReject) => {
            new RetryWorker(3, 500, 
                function() {
                    window.axios.defaults.headers.common['Authorization'] = localStorage.AuthToken;
                    return new Promise((resolve, reject) => {
                        axios.get(process.env.MIX_API_URL + 'queued-bookings', {
                            params: {
                                ...params,
                                fromDate: params.bookingDate.start,
                                toDate: params.bookingDate.end
                            }
                        })
                            // .then(response => new ResponseDataExtractor(response).data)
                            .then(response => {
                                const data = response.data.data;
                                commit('SET_QUEUED_BOOKINGS', {
                                    isLoading: false,
                                    isFetched: true,
                                    listing: data.BookingsList.Bookings.filter(x => x),
                                    totalInFilter: data.noOfBookingsFilteredInQueue,
                                    total: data.totalNoOfBookingsInQueue
                                });
                                resolve(data);
                            })
                            .catch(e => {
                                commit('SET_QUEUED_BOOKINGS', {
                                    isLoading: false,
                                    isFetched: true,
                                    listing: []
                                });
                                console.log('Error when get queued bookings data from api');
                                reject(e);

                                axios.post(process.env.MIX_API_URL +  'send-failed-api-response-email', {
                                    'request_uri': 'queued-bookings'
                                });
                                commit('SET_SHOW_MODAL_RETRY', true);
                            });
                    });
                },
                function(error){
                    mainResolve(error);
                },
                function(error) {
                    mainReject(error);
                },
            ).doWork();
        });
    },
    async updateQueuedBookingStatus({ commit, state }, {
        booking,
        status,
        Comments = '',
        requestDate
    }) {
        if(!booking || !booking.CRN) {
            // Prevent send api if booking data not exist
            return;
        }
        await commit('SET_QUEUED_BOOKING_SUBMITTED', {
            message: '',
            isLoading: true,
            error: false,
            isSubmitted: false
        });
        axios.post(process.env.MIX_API_URL + 'update-queued-booking-status', {
            CRN: booking.CRN,
            Comments: Comments,
            Status: status,
            CustomerId: booking.CustomerId,
            RequestDate: requestDate,
            booking: booking
        })
            .then(response => new ResponseDataExtractor(response).data)
            .then(async (response) => {
                if(response.responseUpdatedStatus.isUpdateSuccessful == 'true') {
                    await commit('SET_QUEUED_BOOKING_SUBMITTED', {
                        message: '',
                        isLoading: false,
                        error: false,
                        isSubmitted: true,
                        submitAction: status
                    })

                    if(status != 'Pending') {
                        commit('SET_SELECTED_QUEUED_BOOKING', null);
                    } else {
                        booking.BookingStatus = status;
                        commit('SET_SELECTED_QUEUED_BOOKING', booking);
                    }

                    commit('SET_QUEUED_BOOKINGS', {
                        ...state.queuedBookings,
                        listing: state.queuedBookings.listing.filter(x => x).map(x => {
                            if(x.CRN == response.InputPayload.CRN) {
                                x.BookingStatus = response.InputPayload.Status
                            }

                            return x;
                        })
                    });
                }
            })
            .catch(e => {
                commit('SET_QUEUED_BOOKING_SUBMITTED', {
                    message: e.response.data.message,
                    isLoading: false,
                    error: true,
                    isSubmitted: true
                })

                if(e.response.status != 400) {
                    console.log('Error when get update queued booking data');
                    axios.post(process.env.MIX_API_URL +  'send-failed-api-response-email', {
                        'request_uri': 'update-queued-booking-status?CRN=' + booking.CRN
                    });
                    commit('SET_SHOW_MODAL_RETRY', true);
                }
            });
    }
}